var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.68 20.83C16.67 20.83 16.65 20.83 16.64 20.83H5.55004C2.61004 20.62 1.29004 18.36 1.29004 16.34C1.29004 14.54 2.34004 12.54 4.63004 11.99C3.99004 9.49 4.53004 7.14 6.16004 5.44C8.01004 3.5 10.98 2.73 13.53 3.52C15.87 4.24 17.52 6.17 18.12 8.85C20.17 9.31 21.8 10.86 22.46 13C23.17 15.33 22.53 17.72 20.78 19.25C19.66 20.26 18.2 20.83 16.68 20.83ZM5.57004 13.35C5.56004 13.35 5.56004 13.35 5.55004 13.35C3.65004 13.49 2.78004 14.95 2.78004 16.34C2.78004 17.73 3.65004 19.19 5.59004 19.33H16.63C17.79 19.31 18.9 18.91 19.76 18.13C21.32 16.76 21.43 14.81 21.01 13.44C20.59 12.06 19.42 10.5 17.38 10.24C17.05 10.2 16.79 9.95 16.73 9.62C16.33 7.22 15.03 5.56 13.08 4.96C11.05 4.34 8.71004 4.95 7.24004 6.48C5.91004 7.87 5.53004 9.79 6.15004 11.9C6.66004 11.97 7.15004 12.12 7.60004 12.35C7.97004 12.54 8.12004 12.99 7.93004 13.36C7.74004 13.73 7.29004 13.88 6.92004 13.69C6.51004 13.48 6.06004 13.37 5.61004 13.37C5.60004 13.35 5.59004 13.35 5.57004 13.35Z",
    fill: "#808288"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.85 10.67C15.57 10.67 15.31 10.52 15.18 10.25C14.99 9.88001 15.15 9.43001 15.52 9.24001C16.14 8.93001 16.83 8.76001 17.51 8.75001C17.91 8.74001 18.27 9.07001 18.27 9.49001C18.28 9.90001 17.95 10.25 17.53 10.25C17.07 10.26 16.6 10.37 16.18 10.58C16.07 10.64 15.96 10.67 15.85 10.67Z",
    fill: "#808288"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.d3582c04aaff519444760478802f98ab.svg";
export { ForwardRef as ReactComponent };